import { fromJS } from 'immutable';
import * as actionTypes from './actionTypes';

const initialState = fromJS({
  userData: {
    isLoading: true,
    data: {},
    error: '',
  },
  advisorsData: {
    isLoading: true,
    data: [],
    error: '',
  },
  filterData: {
    data: {},
    error: '',
  },
  roles: {
    data: [],
  },
  states: {
    data: [],
  },
  lazyData: {
    count: 0,
    isLoading: false,
    data: [],
    error: null,
    accountsAvailable: 0,
  },
  enableBack: false,
});

const financialAdvisorDashboard = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.userDataLoadingType:
      return state.setIn(['advisorsData', 'isLoading'], true);
    case actionTypes.userDataSuccessType:
      return state
        .setIn(['userData', 'data'], action.payload.faUserData)
        .setIn(['advisorsData', 'data'], action.payload.accountsInfo)
        .setIn(['filterData', 'data'], action.payload.filtersAvailable)
        .setIn(['roles', 'data'], action.payload.roles)
        .setIn(['states', 'data'], action.payload.states)
        .setIn(['advisorsData', 'isLoading'], false)
        .setIn(['lazyData', 'count'], state.getIn(['lazyData', 'count']) + 9)
        .setIn(
          ['lazyData', 'accountsAvailable'],
          action.payload.faUserData.noOfManAccts > 9
            ? action.payload.faUserData.noOfManAccts - 9
            : 0
        );
    case actionTypes.enableBackType:
      return state.setIn(['enableBack'], true);
    case actionTypes.resetEnableBackType:
      return state.setIn(['enableBack'], false);
    case actionTypes.lazyLoaderType:
      return state.setIn(['lazyData', 'isLoading'], true);
    case actionTypes.lazyDataFailedType:
      return state
        .setIn(['lazyData', 'isLoading'], false)
        .setIn(['lazyData', 'error'], action.payload);
    case actionTypes.lazyDataSuccessType:
      let noOfAccounts = state.getIn(['lazyData', 'accountsAvailable']) - 9;
      return state
        .setIn(
          ['lazyData', 'accountsAvailable'],
          noOfAccounts > 0 ? noOfAccounts : 0
        )
        .setIn(
          ['advisorsData', 'data'],
          [
            ...state.getIn(['advisorsData', 'data']),
            ...action.payload.accountsInfo,
          ]
        )
        .setIn(['lazyData', 'isLoading'], false)
        .setIn(['lazyData', 'count'], state.getIn(['lazyData', 'count']) + 9);
    case actionTypes.resetAdvisorData:
      return state
        .setIn(['lazyData', 'count'], 0)
        .setIn(['lazyData', 'isLoading'], false)
        .setIn(['lazyData', 'data'], [])
        .setIn(['lazyData', 'error'], null)
        .setIn(['lazyData', 'accountsAvailable'], 0);
    default:
      return state;
  }
};

export default financialAdvisorDashboard;
